<template>
    <div>
        <b-modal id="upload-pt" :title="uploadObject.Id ? 'Düzenle' : 'Ekle'" no-close-on-esc no-close-on-backdrop>
            <psychotechnic-file-upload v-model="uploadObject"></psychotechnic-file-upload>
            <template #modal-footer><v-executer :loading="loading" :action="upload">Kaydet</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    :add-callback="createNew"
                    :settings="false"
                    pagination="server"></v-table>
    </div>
</template>

<script>
import PsychotechnicApi from '@/api/psychotechnic'
import PsychotechnicFileUpload from './components/PsychotechnicFileUpload.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        PsychotechnicFileUpload
    },
    props:{
        id:[String,Number],
    },
    data(){
        return {
            fields:[
                {name:'Başlangıç Zamanı',key:'StartDateValue',thClass:'w-50'},
                {name:'Bitiş Zamanı',key:'EndDateValue',thClass:'w-50'}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"success",action:this.download, condition:item => item.FilePath }
            ],
            loading:false,
            uploadObject:{
                Id:null,
                EmployeeId:this.id,
                StartDate:null,
                EndDate:null,
                File:null
            }
        }
    },
    methods:{
        clearForm(){
            this.uploadObject.Id = null
            this.uploadObject.StartDate = null
            this.uploadObject.EndDate = null
            this.uploadObject.File = null
        },
        edit(item){
            this.clearForm()
            this.uploadObject.Id = item.Id
            this.uploadObject.StartDate = item.StartDate
            this.uploadObject.EndDate = item.EndDate
            this.uploadObject.File = item.FilePath
            this.$showModal('upload-pt')
        },
        createNew(){
            this.clearForm()
            this.$showModal('upload-pt')
        },
        provider(data){
            return PsychotechnicApi.Table({
                ...data,
                EmployeeId:this.id
            })
        },
        upload(){
            const formData = new FormData()
            if(this.uploadObject.Id) formData.append('Id', this.uploadObject.Id)
            formData.append('EmployeeId',this.id)
            if(this.uploadObject.StartDate) formData.append('StartDate',this.uploadObject.StartDate)
            if(this.uploadObject.EndDate) formData.append('EndDate',this.uploadObject.EndDate)
            if(this.uploadObject.File != null && typeof this.uploadObject.File === 'object') {
                formData.append('File',this.uploadObject.File)
            }            
            this.loading = true
            const request = this.uploadObject.Id
                ? PsychotechnicApi.Update(formData)
                : PsychotechnicApi.Create(formData)
                
            request.then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload-pt')
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem psikoteknik belgesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    PsychotechnicApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        download(item){
            Additional.DownloadTab(item.FilePath)
        }
    }
}
</script>